import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-leaflet-task-intent-panel',
  templateUrl: './leaflet-task-intent-panel.component.html',
  styleUrls: ['./leaflet-task-intent-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeafletTaskIntentPanelComponent implements OnChanges {
  @Input() open = false;
  @Input() stripAvailable = false;
  @Input() swathKm = 8;
  @Input() stripEnabled = false;
  @Input() lengthKm: number | null = null;
  @Input() validMin: number | null = null;
  @Input() validMax: number | null = null;

  @Output() openChange = new EventEmitter<boolean>();
  @Output() stripEnabledChange = new EventEmitter<boolean>();

  stripItemExpanded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['stripAvailable']) {
      if (this.stripAvailable) {
        this.stripItemExpanded = true;
      } else {
        this.stripItemExpanded = false;
      }
    }
  }

  togglePanel(): void {
    this.openChange.emit(!this.open);
  }

  toggleStripItem(): void {
    if (this.stripAvailable) {
      this.stripItemExpanded = !this.stripItemExpanded;
    }
  }

  onStripToggle(enabled: boolean): void {
    this.stripEnabledChange.emit(enabled);
  }

  get lengthColor(): string | null {
    if (this.lengthKm === null || this.validMin === null || this.validMax === null) {
      return null;
    }
    return this.lengthKm >= this.validMin && this.lengthKm <= this.validMax
      ? '#43a047'
      : '#e53935';
  }

  get isLengthValid(): boolean | null {
    if (this.lengthKm === null || this.validMin === null || this.validMax === null) {
      return null;
    }
    return this.lengthKm >= this.validMin && this.lengthKm <= this.validMax;
  }
}
